module.exports = __webpack_public_path__ + "static/media/MenuKidsSlider.fe569d8c.jpg";